<template>
    <div class="m-tc-fullscreen-loader"
         v-if="isVisible">
        <MobileSpinner/>
        Подождите...
    </div>
</template>

<script>



import MobileSpinner from '@/UI/Mobile/MobileSpinner.vue';

export default {
    name: 'MobileLoader',
    components: { MobileSpinner },
    props: [
        'isVisible',
    ],
};
</script>

<style scoped lang="scss">
.m-tc-fullscreen-loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: 1s ease all;
    background-color: #FFFFFF;
    pointer-events: all;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    color: #00458D;
    z-index: 1000;
    font-family: Montserrat, sans-serif;
    user-select: none;
}
</style>
